import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACCESS_OWN_ACCURACY_REPORT } from "helpers/role";
import Permission from "components/hoc/Permission";
import { getAccuracy } from "store/actions/clientAction";
import Translate from "helpers/Translate";

export const Accuracy = () => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.client.isLoadingClient);
  const client = useSelector(state => state.client.selectedClient);
  const getUserAccuracy = useSelector(state => state.client.getAccuracy);

  // Fetch the accuracy of the logged in user
  useEffect(() => {
    if (client.id) {
      dispatch(getAccuracy(client.id));
    }
  }, [client.id, dispatch]);

  const calculatePercentage = () => {
    const approvals = getUserAccuracy?.approvals || 0;
    const rejections = getUserAccuracy?.rejections || 0;

    const percentage = (approvals / (approvals + rejections)) * 100;
    if (isNaN(percentage)) return 0;
    return percentage.toFixed(2);
  };

  return (
    <div className="accuracy-container">
      <h1 className="title mb-40">
        {Translate({ id: "my_accuracy_report" })}
        <i
          title="Refresh"
          className="fas fa-sync-alt  pointer ml-10"
          onClick={() => dispatch(getAccuracy(client.id))}
        ></i>
      </h1>
      <Permission resources={[ACCESS_OWN_ACCURACY_REPORT]}>
        <ul className="data">
          <li className="my-20">
            <strong className="mr-5">
              {Translate({ id: "total_submissions" })}:
            </strong>
            <span>
              <b>{loading ? "..." : getUserAccuracy?.submissions || 0}</b>
            </span>
          </li>
          {/* <li className="my-20">
            <strong className="mr-5">
              {Translate({ id: "unique_submissions" })} :
            </strong>
            <span>
              <b>{loading ? "..." : totalUniqueSubmissions}</b>
            </span>
          </li> */}
          <li className="my-20">
            <strong className="mr-5">
              {Translate({ id: "total_approvals" })} :
            </strong>
            <span>
              <b>{loading ? "..." : getUserAccuracy?.approvals || 0}</b>
            </span>
          </li>
          <li className="my-20">
            <strong className="mr-5">
              {Translate({ id: "total_rejected" })} :
            </strong>
            <span>
              <b>{loading ? "..." : getUserAccuracy?.rejections || 0}</b>
            </span>
          </li>
          <li className="my-20">
            <strong className="mr-5">
              {Translate({ id: "percentage" })} :
            </strong>
            <span>
              <b>{loading ? "..." : `${calculatePercentage()}%`}</b>
            </span>
          </li>
        </ul>
      </Permission>
    </div>
  );
};

export default Accuracy;
